import React from 'react';
import { useNavigate } from 'react-router-dom';
import 'survey-core/defaultV2.min.css';
import { HealthDataSurvey } from '#components';
import { Routes } from '#Routes';
import { alert } from '#utils';
import { useTranslation } from 'react-i18next';

const HealthDataSurveyPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const onComplete = (interview) => {
    alert.fire({
      icon: 'success',
      title: t('health-data-survey.success-message'),
      showConfirmButton: true,
      timer: 2000,
    }).then(() => {
      navigate(Routes.Dashboard.path);
    });
  };

  return (
    <>
      <HealthDataSurvey onComplete={onComplete} />
    </>
  );
};

export default HealthDataSurveyPage;
